import { render, staticRenderFns } from "./CardC.vue?vue&type=template&id=582f33b0&"
import script from "./CardC.vue?vue&type=script&lang=js&"
export * from "./CardC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports